import axios from 'axios';
import { ApiResponse } from '../types/api';
import { BlacklistAttemptLog } from '../types/blacklistLog';

export const blacklistLogService = {
  getLogs: async (): Promise<BlacklistAttemptLog[]> => {
    const res = await axios.get<ApiResponse<BlacklistAttemptLog[]>>(
      '/api/admin/blacklist-logs',
      { withCredentials: true }
    );
    return res.data.data;
  },
};
